export default "__VITE_ASSET__YFK0LVdR__"